import { faUserGroup } from '@fortawesome/pro-regular-svg-icons/faUserGroup'
import { Card, Button, Text, Flex, Skeleton } from '@mantine/core'
import { useCallback } from 'react'

import {
  useMutationCreateCustomerFromInquiry,
  useQueryGetInquiryById,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { Badge, Icon } from '@flecto/ui'

import { BadgeInquiryCustomer } from '../BadgeInquiryCustomer/BadgeInquiryCustomer'

export type CardInquiryCustomerProps = {
  inquiryId: number
}

export function CardInquiryCustomer({ inquiryId }: CardInquiryCustomerProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })
  const { mutateAsync: createCustomer } = useMutationCreateCustomerFromInquiry()
  const { data, isLoading } = useQueryGetInquiryById({ inquiryId })

  const inquiry = data?.inquiry

  const handleAddCustomer = useCallback(() => {
    createCustomer({ inquiryId: Number(inquiry?.internal_id) })
  }, [inquiry])

  const getBadge = () => {
    if (inquiry?.customer) {
      return <BadgeInquiryCustomer inquiry={inquiry} />
    } else {
      return <Badge>{t('label_new_customer')}</Badge>
    }
  }

  const customerPhone = `${inquiry?.phone_number_country_code} ${inquiry?.phone_number}`

  return (
    <Card>
      <Text fw={500} mb='xs'>
        {t('sent_by')}
      </Text>
      <Flex align='center' gap='sm'>
        <Text c='dimmed'>{t('customer_identified_as')}</Text>
        {getBadge()}
      </Flex>
      {isLoading ? (
        <Skeleton h={20} w={200} mt='md' />
      ) : (
        <Flex align='center' gap='sm' mt='md'>
          <Text>{inquiry?.full_name}</Text>
          &bull;
          <Text>{inquiry?.email}</Text>
          &bull;
          <Text>{customerPhone}</Text>
        </Flex>
      )}
      {!inquiry?.customer && inquiry?.status === 'requested' && (
        <Button
          mt='md'
          size='sm'
          variant='outline'
          onClick={handleAddCustomer}
          leftSection={<Icon icon={faUserGroup} />}
        >
          {t('add_to_customers_list')}
        </Button>
      )}
    </Card>
  )
}
